import { useNavigate } from 'react-router-dom';
import { Button, Card } from 'react-bootstrap';
import { FaUserLock } from 'react-icons/fa';

import styled from 'styled-components';

export const AccessDeniedStyled = styled.div`
  min-height: 100vh;
  background: linear-gradient(30deg, #9459d0 0%, #027c8b 50%, #0d4693 100%);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledCard = styled(Card)`
  max-width: 600px;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const ErrorAccessDeniedPage: React.FC = () => {
  const navigate = useNavigate();

  function handleGoHome(): void {
    navigate('/');
  }

  function handleLogin(): void {
    localStorage.clear();
    navigate('/');
    // eslint-disable-next-line no-restricted-globals
    location.reload();
  }

  return (
    <AccessDeniedStyled>
      <StyledCard>
        <Card.Body>
          <FaUserLock color={'#DC3444'} style={{ fontSize: 120 }} />
          <Card.Title className="mt-4" style={{ fontSize: '28px', fontWeight: 'bold' }}>
            Acesso Negado
          </Card.Title>
          <Card.Text style={{ fontSize: '18px', marginTop: '10px', lineHeight: '1.5' }}>
            Você não tem permissão para acessar esta página. Isso pode ocorrer devido a restrições de acesso ou falta de permissões adequadas.
            <br />
            <strong>Por favor, utilize uma das opções abaixo:</strong>
          </Card.Text>
          <div>
            <Button style={{ marginRight: '2%' }} variant="primary" onClick={handleGoHome}>
              Voltar para Home
            </Button>
            <Button variant="outline-primary" onClick={handleLogin}>
              Fazer Login
            </Button>
          </div>
        </Card.Body>
      </StyledCard>
    </AccessDeniedStyled>
  );
};

export default ErrorAccessDeniedPage;
